function getCookie(key) {
    var reg = new RegExp("(?:^|;+|\\s+)".concat(key, "=([^;]*)"));
    var match = typeof document === 'object' && document.cookie.match(reg);
    return match ? match[1] : null;
}
function setCookie(key, value, hours, domain, path) {
    var expire = new Date();
    expire.setTime(expire.getTime() + (hours ? 60 * 60 * 1000 * hours : 30 * 24 * 60 * 60 * 1000));
    if (typeof document !== 'undefined') {
        document.cookie = "".concat(key, "=").concat(value, ";expires=").concat(expire.toGMTString(), ";path=").concat(path || '/', ";").concat(domain ? ("domain=".concat(domain, ";")) : '');
    }
}

function getUrlParameter(paramKey) {
    var search = window.location.search.substring(1);
    if (!search) {
        return;
    }
    var kvArray = search.split('&');
    for (var _i = 0, kvArray_1 = kvArray; _i < kvArray_1.length; _i++) {
        var kv = kvArray_1[_i];
        var _a = kv.split('='), key = _a[0], value = _a[1];
        if (key === paramKey) {
            return value;
        }
    }
}

function getVersionWithName(name, ua) {
    if (ua === void 0) { ua = window.navigator.userAgent; }
    try {
        var pattern = new RegExp("\\b".concat(name, "\\/((\\d+\\.){1,3}\\d+)"), 'i');
        var match = pattern.exec(ua);
        return (match && match.length > 1 && match[1]) || '';
    }
    catch (err) {
        return '';
    }
}

var FILE_TYPE_MAP = {
    doc: 1,
    sheet: 2,
    form: 3,
    slide: 4,
    pdf: 7,
    mind: 8,
    flowchart: 9,
    rec: 10,
};
var UTYPE_MAP = {
    qq: 1,
    wx: 2,
    ww: 5,
};
var errorNumber = -1;
var booleanToNumber = {
    errorNumber: -1,
    trueNumber: 1,
    falseNumber: 0,
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var dist = {exports: {}};

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function (module, exports) {
  !function (t, e) {
    module.exports = e() ;
  }("undefined" != typeof window ? window : commonjsGlobal, function () {
    return function (t) {
      var e = {};

      function n(r) {
        if (e[r]) return e[r].exports;
        var i = e[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
      }

      return n.m = t, n.c = e, n.d = function (t, e, r) {
        n.o(t, e) || Object.defineProperty(t, e, {
          enumerable: !0,
          get: r
        });
      }, n.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }, n.t = function (t, e) {
        if (1 & e && (t = n(t)), 8 & e) return t;
        if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: t
        }), 2 & e && "string" != typeof t) for (var i in t) {
          n.d(r, i, function (e) {
            return t[e];
          }.bind(null, i));
        }
        return r;
      }, n.n = function (t) {
        var e = t && t.__esModule ? function () {
          return t["default"];
        } : function () {
          return t;
        };
        return n.d(e, "a", e), e;
      }, n.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, n.p = "", n(n.s = 74);
    }([function (t, e) {
      var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
      "number" == typeof __g && (__g = n);
    }, function (t, e, n) {
      t.exports = !n(3)(function () {
        return 7 != Object.defineProperty({}, "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    }, function (t, e, n) {
      var r = n(5);

      t.exports = function (t) {
        if (!r(t)) throw TypeError(t + " is not an object!");
        return t;
      };
    }, function (t, e) {
      t.exports = function (t) {
        try {
          return !!t();
        } catch (t) {
          return !0;
        }
      };
    }, function (t, e, n) {
      var r = n(18)("wks"),
          i = n(17),
          o = n(0).Symbol,
          u = "function" == typeof o;
      (t.exports = function (t) {
        return r[t] || (r[t] = u && o[t] || (u ? o : i)("Symbol." + t));
      }).store = r;
    }, function (t, e) {
      t.exports = function (t) {
        return "object" == _typeof(t) ? null !== t : "function" == typeof t;
      };
    }, function (t, e, n) {
      var r = n(0),
          i = n(15),
          o = n(11),
          u = n(12),
          s = n(19),
          c = function c(t, e, n) {
        var f,
            a,
            l,
            p,
            g = t & c.F,
            h = t & c.G,
            v = t & c.S,
            d = t & c.P,
            y = t & c.B,
            x = h ? r : v ? r[e] || (r[e] = {}) : (r[e] || {}).prototype,
            A = h ? i : i[e] || (i[e] = {}),
            b = A.prototype || (A.prototype = {});

        for (f in h && (n = e), n) {
          l = ((a = !g && x && void 0 !== x[f]) ? x : n)[f], p = y && a ? s(l, r) : d && "function" == typeof l ? s(Function.call, l) : l, x && u(x, f, l, t & c.U), A[f] != l && o(A, f, p), d && b[f] != l && (b[f] = l);
        }
      };

      r.core = i, c.F = 1, c.G = 2, c.S = 4, c.P = 8, c.B = 16, c.W = 32, c.U = 64, c.R = 128, t.exports = c;
    }, function (t, e, n) {
      var r = n(2),
          i = n(25),
          o = n(16),
          u = Object.defineProperty;
      e.f = n(1) ? Object.defineProperty : function (t, e, n) {
        if (r(t), e = o(e, !0), r(n), i) try {
          return u(t, e, n);
        } catch (t) {}
        if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
        return "value" in n && (t[e] = n.value), t;
      };
    }, function (t, e) {
      t.exports = function (t) {
        if (null == t) throw TypeError("Can't call method on  " + t);
        return t;
      };
    }, function (t, e, n) {
      var r = n(14),
          i = Math.min;

      t.exports = function (t) {
        return t > 0 ? i(r(t), 9007199254740991) : 0;
      };
    }, function (t, e) {
      var n = {}.toString;

      t.exports = function (t) {
        return n.call(t).slice(8, -1);
      };
    }, function (t, e, n) {
      var r = n(7),
          i = n(27);
      t.exports = n(1) ? function (t, e, n) {
        return r.f(t, e, i(1, n));
      } : function (t, e, n) {
        return t[e] = n, t;
      };
    }, function (t, e, n) {
      var r = n(0),
          i = n(11),
          o = n(13),
          u = n(17)("src"),
          s = n(46),
          c = ("" + s).split("toString");
      n(15).inspectSource = function (t) {
        return s.call(t);
      }, (t.exports = function (t, e, n, s) {
        var f = "function" == typeof n;
        f && (o(n, "name") || i(n, "name", e)), t[e] !== n && (f && (o(n, u) || i(n, u, t[e] ? "" + t[e] : c.join(String(e)))), t === r ? t[e] = n : s ? t[e] ? t[e] = n : i(t, e, n) : (delete t[e], i(t, e, n)));
      })(Function.prototype, "toString", function () {
        return "function" == typeof this && this[u] || s.call(this);
      });
    }, function (t, e) {
      var n = {}.hasOwnProperty;

      t.exports = function (t, e) {
        return n.call(t, e);
      };
    }, function (t, e) {
      var n = Math.ceil,
          r = Math.floor;

      t.exports = function (t) {
        return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
      };
    }, function (t, e) {
      var n = t.exports = {
        version: "2.6.11"
      };
      "number" == typeof __e && (__e = n);
    }, function (t, e, n) {
      var r = n(5);

      t.exports = function (t, e) {
        if (!r(t)) return t;
        var n, i;
        if (e && "function" == typeof (n = t.toString) && !r(i = n.call(t))) return i;
        if ("function" == typeof (n = t.valueOf) && !r(i = n.call(t))) return i;
        if (!e && "function" == typeof (n = t.toString) && !r(i = n.call(t))) return i;
        throw TypeError("Can't convert object to primitive value");
      };
    }, function (t, e) {
      var n = 0,
          r = Math.random();

      t.exports = function (t) {
        return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36));
      };
    }, function (t, e, n) {
      var r = n(15),
          i = n(0),
          o = i["__core-js_shared__"] || (i["__core-js_shared__"] = {});
      (t.exports = function (t, e) {
        return o[t] || (o[t] = void 0 !== e ? e : {});
      })("versions", []).push({
        version: r.version,
        mode: n(47) ? "pure" : "global",
        copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
      });
    }, function (t, e, n) {
      var r = n(28);

      t.exports = function (t, e, n) {
        if (r(t), void 0 === e) return t;

        switch (n) {
          case 1:
            return function (n) {
              return t.call(e, n);
            };

          case 2:
            return function (n, r) {
              return t.call(e, n, r);
            };

          case 3:
            return function (n, r, i) {
              return t.call(e, n, r, i);
            };
        }

        return function () {
          return t.apply(e, arguments);
        };
      };
    }, function (t, e, n) {
      var r = n(8);

      t.exports = function (t) {
        return Object(r(t));
      };
    }, function (t, e, n) {
      var r = n(32),
          i = n(8);

      t.exports = function (t) {
        return r(i(t));
      };
    }, function (t, e) {
      t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    }, function (t, e, n) {

      var r,
          i,
          o = n(41),
          u = RegExp.prototype.exec,
          s = String.prototype.replace,
          c = u,
          f = (r = /a/, i = /b*/g, u.call(r, "a"), u.call(i, "a"), 0 !== r.lastIndex || 0 !== i.lastIndex),
          a = void 0 !== /()??/.exec("")[1];
      (f || a) && (c = function c(t) {
        var e,
            n,
            r,
            i,
            c = this;
        return a && (n = new RegExp("^" + c.source + "$(?!\\s)", o.call(c))), f && (e = c.lastIndex), r = u.call(c, t), f && r && (c.lastIndex = c.global ? r.index + r[0].length : e), a && r && r.length > 1 && s.call(r[0], n, function () {
          for (i = 1; i < arguments.length - 2; i++) {
            void 0 === arguments[i] && (r[i] = void 0);
          }
        }), r;
      }), t.exports = c;
    }, function (t, e) {
      function n(e) {
        return "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? t.exports = n = function n(t) {
          return _typeof(t);
        } : t.exports = n = function n(t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
        }, n(e);
      }

      t.exports = n;
    }, function (t, e, n) {
      t.exports = !n(1) && !n(3)(function () {
        return 7 != Object.defineProperty(n(26)("div"), "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    }, function (t, e, n) {
      var r = n(5),
          i = n(0).document,
          o = r(i) && r(i.createElement);

      t.exports = function (t) {
        return o ? i.createElement(t) : {};
      };
    }, function (t, e) {
      t.exports = function (t, e) {
        return {
          enumerable: !(1 & t),
          configurable: !(2 & t),
          writable: !(4 & t),
          value: e
        };
      };
    }, function (t, e) {
      t.exports = function (t) {
        if ("function" != typeof t) throw TypeError(t + " is not a function!");
        return t;
      };
    }, function (t, e, n) {
      var r = n(14),
          i = Math.max,
          o = Math.min;

      t.exports = function (t, e) {
        return (t = r(t)) < 0 ? i(t + e, 0) : o(t, e);
      };
    }, function (t, e, n) {
      var r = n(4)("unscopables"),
          i = Array.prototype;
      null == i[r] && n(11)(i, r, {}), t.exports = function (t) {
        i[r][t] = !0;
      };
    }, function (t, e, n) {
      var r = n(19),
          i = n(32),
          o = n(20),
          u = n(9),
          s = n(51);

      t.exports = function (t, e) {
        var n = 1 == t,
            c = 2 == t,
            f = 3 == t,
            a = 4 == t,
            l = 6 == t,
            p = 5 == t || l,
            g = e || s;
        return function (e, s, h) {
          for (var v, d, y = o(e), x = i(y), A = r(s, h, 3), b = u(x.length), m = 0, w = n ? g(e, b) : c ? g(e, 0) : void 0; b > m; m++) {
            if ((p || m in x) && (d = A(v = x[m], m, y), t)) if (n) w[m] = d;else if (d) switch (t) {
              case 3:
                return !0;

              case 5:
                return v;

              case 6:
                return m;

              case 2:
                w.push(v);
            } else if (a) return !1;
          }

          return l ? -1 : f || a ? a : w;
        };
      };
    }, function (t, e, n) {
      var r = n(10);
      t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
        return "String" == r(t) ? t.split("") : Object(t);
      };
    }, function (t, e, n) {
      var r = n(5),
          i = n(55).set;

      t.exports = function (t, e, n) {
        var o,
            u = e.constructor;
        return u !== n && "function" == typeof u && (o = u.prototype) !== n.prototype && r(o) && i && i(t, o), t;
      };
    }, function (t, e, n) {
      var r = n(56),
          i = n(27),
          o = n(21),
          u = n(16),
          s = n(13),
          c = n(25),
          f = Object.getOwnPropertyDescriptor;
      e.f = n(1) ? f : function (t, e) {
        if (t = o(t), e = u(e, !0), c) try {
          return f(t, e);
        } catch (t) {}
        if (s(t, e)) return i(!r.f.call(t, e), t[e]);
      };
    }, function (t, e, n) {
      var r = n(36),
          i = n(22).concat("length", "prototype");

      e.f = Object.getOwnPropertyNames || function (t) {
        return r(t, i);
      };
    }, function (t, e, n) {
      var r = n(13),
          i = n(21),
          o = n(57)(!1),
          u = n(37)("IE_PROTO");

      t.exports = function (t, e) {
        var n,
            s = i(t),
            c = 0,
            f = [];

        for (n in s) {
          n != u && r(s, n) && f.push(n);
        }

        for (; e.length > c;) {
          r(s, n = e[c++]) && (~o(f, n) || f.push(n));
        }

        return f;
      };
    }, function (t, e, n) {
      var r = n(18)("keys"),
          i = n(17);

      t.exports = function (t) {
        return r[t] || (r[t] = i(t));
      };
    }, function (t, e, n) {
      var r = n(5),
          i = n(10),
          o = n(4)("match");

      t.exports = function (t) {
        var e;
        return r(t) && (void 0 !== (e = t[o]) ? !!e : "RegExp" == i(t));
      };
    }, function (t, e, n) {

      var r = n(66)(!0);

      t.exports = function (t, e, n) {
        return e + (n ? r(t, e).length : 1);
      };
    }, function (t, e, n) {

      var r = n(67),
          i = RegExp.prototype.exec;

      t.exports = function (t, e) {
        var n = t.exec;

        if ("function" == typeof n) {
          var o = n.call(t, e);
          if ("object" != _typeof(o)) throw new TypeError("RegExp exec method returned something other than an Object or null");
          return o;
        }

        if ("RegExp" !== r(t)) throw new TypeError("RegExp#exec called on incompatible receiver");
        return i.call(t, e);
      };
    }, function (t, e, n) {

      var r = n(2);

      t.exports = function () {
        var t = r(this),
            e = "";
        return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
      };
    }, function (t, e, n) {

      n(68);

      var r = n(12),
          i = n(11),
          o = n(3),
          u = n(8),
          s = n(4),
          c = n(23),
          f = s("species"),
          a = !o(function () {
        var t = /./;
        return t.exec = function () {
          var t = [];
          return t.groups = {
            a: "7"
          }, t;
        }, "7" !== "".replace(t, "$<a>");
      }),
          l = function () {
        var t = /(?:)/,
            e = t.exec;

        t.exec = function () {
          return e.apply(this, arguments);
        };

        var n = "ab".split(t);
        return 2 === n.length && "a" === n[0] && "b" === n[1];
      }();

      t.exports = function (t, e, n) {
        var p = s(t),
            g = !o(function () {
          var e = {};
          return e[p] = function () {
            return 7;
          }, 7 != ""[t](e);
        }),
            h = g ? !o(function () {
          var e = !1,
              n = /a/;
          return n.exec = function () {
            return e = !0, null;
          }, "split" === t && (n.constructor = {}, n.constructor[f] = function () {
            return n;
          }), n[p](""), !e;
        }) : void 0;

        if (!g || !h || "replace" === t && !a || "split" === t && !l) {
          var v = /./[p],
              d = n(u, p, ""[t], function (t, e, n, r, i) {
            return e.exec === c ? g && !i ? {
              done: !0,
              value: v.call(e, n, r)
            } : {
              done: !0,
              value: t.call(n, e, r)
            } : {
              done: !1
            };
          }),
              y = d[0],
              x = d[1];
          r(String.prototype, t, y), i(RegExp.prototype, p, 2 == e ? function (t, e) {
            return x.call(t, this, e);
          } : function (t) {
            return x.call(t, this);
          });
        }
      };
    }, function (t, e) {
      t.exports = function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      };
    }, function (t, e) {
      function n(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      t.exports = function (t, e, r) {
        return e && n(t.prototype, e), r && n(t, r), t;
      };
    }, function (t, e, n) {
      var r = n(6);
      r(r.S + r.F * !n(1), "Object", {
        defineProperty: n(7).f
      });
    }, function (t, e, n) {
      t.exports = n(18)("native-function-to-string", Function.toString);
    }, function (t, e) {
      t.exports = !1;
    }, function (t, e, n) {
      var r = n(6);
      r(r.P, "Array", {
        fill: n(49)
      }), n(30)("fill");
    }, function (t, e, n) {

      var r = n(20),
          i = n(29),
          o = n(9);

      t.exports = function (t) {
        for (var e = r(this), n = o(e.length), u = arguments.length, s = i(u > 1 ? arguments[1] : void 0, n), c = u > 2 ? arguments[2] : void 0, f = void 0 === c ? n : i(c, n); f > s;) {
          e[s++] = t;
        }

        return e;
      };
    }, function (t, e, n) {

      var r = n(6),
          i = n(31)(5),
          o = !0;
      "find" in [] && Array(1).find(function () {
        o = !1;
      }), r(r.P + r.F * o, "Array", {
        find: function find(t) {
          return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
      }), n(30)("find");
    }, function (t, e, n) {
      var r = n(52);

      t.exports = function (t, e) {
        return new (r(t))(e);
      };
    }, function (t, e, n) {
      var r = n(5),
          i = n(53),
          o = n(4)("species");

      t.exports = function (t) {
        var e;
        return i(t) && ("function" != typeof (e = t.constructor) || e !== Array && !i(e.prototype) || (e = void 0), r(e) && null === (e = e[o]) && (e = void 0)), void 0 === e ? Array : e;
      };
    }, function (t, e, n) {
      var r = n(10);

      t.exports = Array.isArray || function (t) {
        return "Array" == r(t);
      };
    }, function (t, e, n) {

      var r = n(0),
          i = n(13),
          o = n(10),
          u = n(33),
          s = n(16),
          c = n(3),
          f = n(35).f,
          a = n(34).f,
          l = n(7).f,
          p = n(58).trim,
          _g = r.Number,
          h = _g,
          v = _g.prototype,
          d = "Number" == o(n(60)(v)),
          y = ("trim" in String.prototype),
          x = function x(t) {
        var e = s(t, !1);

        if ("string" == typeof e && e.length > 2) {
          var n,
              r,
              i,
              o = (e = y ? e.trim() : p(e, 3)).charCodeAt(0);

          if (43 === o || 45 === o) {
            if (88 === (n = e.charCodeAt(2)) || 120 === n) return NaN;
          } else if (48 === o) {
            switch (e.charCodeAt(1)) {
              case 66:
              case 98:
                r = 2, i = 49;
                break;

              case 79:
              case 111:
                r = 8, i = 55;
                break;

              default:
                return +e;
            }

            for (var u, c = e.slice(2), f = 0, a = c.length; f < a; f++) {
              if ((u = c.charCodeAt(f)) < 48 || u > i) return NaN;
            }

            return parseInt(c, r);
          }
        }

        return +e;
      };

      if (!_g(" 0o1") || !_g("0b1") || _g("+0x1")) {
        _g = function g(t) {
          var e = arguments.length < 1 ? 0 : t,
              n = this;
          return n instanceof _g && (d ? c(function () {
            v.valueOf.call(n);
          }) : "Number" != o(n)) ? u(new h(x(e)), n, _g) : x(e);
        };

        for (var A, b = n(1) ? f(h) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), m = 0; b.length > m; m++) {
          i(h, A = b[m]) && !i(_g, A) && l(_g, A, a(h, A));
        }

        _g.prototype = v, v.constructor = _g, n(12)(r, "Number", _g);
      }
    }, function (t, e, n) {
      var r = n(5),
          i = n(2),
          o = function o(t, e) {
        if (i(t), !r(e) && null !== e) throw TypeError(e + ": can't set as prototype!");
      };

      t.exports = {
        set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, e, r) {
          try {
            (r = n(19)(Function.call, n(34).f(Object.prototype, "__proto__").set, 2))(t, []), e = !(t instanceof Array);
          } catch (t) {
            e = !0;
          }

          return function (t, n) {
            return o(t, n), e ? t.__proto__ = n : r(t, n), t;
          };
        }({}, !1) : void 0),
        check: o
      };
    }, function (t, e) {
      e.f = {}.propertyIsEnumerable;
    }, function (t, e, n) {
      var r = n(21),
          i = n(9),
          o = n(29);

      t.exports = function (t) {
        return function (e, n, u) {
          var s,
              c = r(e),
              f = i(c.length),
              a = o(u, f);

          if (t && n != n) {
            for (; f > a;) {
              if ((s = c[a++]) != s) return !0;
            }
          } else for (; f > a; a++) {
            if ((t || a in c) && c[a] === n) return t || a || 0;
          }

          return !t && -1;
        };
      };
    }, function (t, e, n) {
      var r = n(6),
          i = n(8),
          o = n(3),
          u = n(59),
          s = "[" + u + "]",
          c = RegExp("^" + s + s + "*"),
          f = RegExp(s + s + "*$"),
          a = function a(t, e, n) {
        var i = {},
            s = o(function () {
          return !!u[t]() || "​" != "​"[t]();
        }),
            c = i[t] = s ? e(l) : u[t];
        n && (i[n] = c), r(r.P + r.F * s, "String", i);
      },
          l = a.trim = function (t, e) {
        return t = String(i(t)), 1 & e && (t = t.replace(c, "")), 2 & e && (t = t.replace(f, "")), t;
      };

      t.exports = a;
    }, function (t, e) {
      t.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
    }, function (t, e, n) {
      var r = n(2),
          i = n(61),
          o = n(22),
          u = n(37)("IE_PROTO"),
          s = function s() {},
          _c = function c() {
        var t,
            e = n(26)("iframe"),
            r = o.length;

        for (e.style.display = "none", n(63).appendChild(e), e.src = "javascript:", (t = e.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), _c = t.F; r--;) {
          delete _c.prototype[o[r]];
        }

        return _c();
      };

      t.exports = Object.create || function (t, e) {
        var n;
        return null !== t ? (s.prototype = r(t), n = new s(), s.prototype = null, n[u] = t) : n = _c(), void 0 === e ? n : i(n, e);
      };
    }, function (t, e, n) {
      var r = n(7),
          i = n(2),
          o = n(62);
      t.exports = n(1) ? Object.defineProperties : function (t, e) {
        i(t);

        for (var n, u = o(e), s = u.length, c = 0; s > c;) {
          r.f(t, n = u[c++], e[n]);
        }

        return t;
      };
    }, function (t, e, n) {
      var r = n(36),
          i = n(22);

      t.exports = Object.keys || function (t) {
        return r(t, i);
      };
    }, function (t, e, n) {
      var r = n(0).document;
      t.exports = r && r.documentElement;
    }, function (t, e, n) {

      var r = n(38),
          i = n(2),
          o = n(65),
          u = n(39),
          s = n(9),
          c = n(40),
          f = n(23),
          a = n(3),
          l = Math.min,
          p = [].push,
          g = "length",
          h = !a(function () {
      });
      n(42)("split", 2, function (t, e, n, a) {
        var v;
        return v = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1)[g] || 2 != "ab".split(/(?:ab)*/)[g] || 4 != ".".split(/(.?)(.?)/)[g] || ".".split(/()()/)[g] > 1 || "".split(/.?/)[g] ? function (t, e) {
          var i = String(this);
          if (void 0 === t && 0 === e) return [];
          if (!r(t)) return n.call(i, t, e);

          for (var o, u, s, c = [], a = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""), l = 0, h = void 0 === e ? 4294967295 : e >>> 0, v = new RegExp(t.source, a + "g"); (o = f.call(v, i)) && !((u = v.lastIndex) > l && (c.push(i.slice(l, o.index)), o[g] > 1 && o.index < i[g] && p.apply(c, o.slice(1)), s = o[0][g], l = u, c[g] >= h));) {
            v.lastIndex === o.index && v.lastIndex++;
          }

          return l === i[g] ? !s && v.test("") || c.push("") : c.push(i.slice(l)), c[g] > h ? c.slice(0, h) : c;
        } : "0".split(void 0, 0)[g] ? function (t, e) {
          return void 0 === t && 0 === e ? [] : n.call(this, t, e);
        } : n, [function (n, r) {
          var i = t(this),
              o = null == n ? void 0 : n[e];
          return void 0 !== o ? o.call(n, i, r) : v.call(String(i), n, r);
        }, function (t, e) {
          var r = a(v, t, this, e, v !== n);
          if (r.done) return r.value;
          var f = i(t),
              p = String(this),
              g = o(f, RegExp),
              d = f.unicode,
              y = (f.ignoreCase ? "i" : "") + (f.multiline ? "m" : "") + (f.unicode ? "u" : "") + (h ? "y" : "g"),
              x = new g(h ? f : "^(?:" + f.source + ")", y),
              A = void 0 === e ? 4294967295 : e >>> 0;
          if (0 === A) return [];
          if (0 === p.length) return null === c(x, p) ? [p] : [];

          for (var b = 0, m = 0, w = []; m < p.length;) {
            x.lastIndex = h ? m : 0;
            var Q,
                M = c(x, h ? p : p.slice(m));
            if (null === M || (Q = l(s(x.lastIndex + (h ? 0 : m)), p.length)) === b) m = u(p, m, d);else {
              if (w.push(p.slice(b, m)), w.length === A) return w;

              for (var S = 1; S <= M.length - 1; S++) {
                if (w.push(M[S]), w.length === A) return w;
              }

              m = b = Q;
            }
          }

          return w.push(p.slice(b)), w;
        }];
      });
    }, function (t, e, n) {
      var r = n(2),
          i = n(28),
          o = n(4)("species");

      t.exports = function (t, e) {
        var n,
            u = r(t).constructor;
        return void 0 === u || null == (n = r(u)[o]) ? e : i(n);
      };
    }, function (t, e, n) {
      var r = n(14),
          i = n(8);

      t.exports = function (t) {
        return function (e, n) {
          var o,
              u,
              s = String(i(e)),
              c = r(n),
              f = s.length;
          return c < 0 || c >= f ? t ? "" : void 0 : (o = s.charCodeAt(c)) < 55296 || o > 56319 || c + 1 === f || (u = s.charCodeAt(c + 1)) < 56320 || u > 57343 ? t ? s.charAt(c) : o : t ? s.slice(c, c + 2) : u - 56320 + (o - 55296 << 10) + 65536;
        };
      };
    }, function (t, e, n) {
      var r = n(10),
          i = n(4)("toStringTag"),
          o = "Arguments" == r(function () {
        return arguments;
      }());

      t.exports = function (t) {
        var e, n, u;
        return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = function (t, e) {
          try {
            return t[e];
          } catch (t) {}
        }(e = Object(t), i)) ? n : o ? r(e) : "Object" == (u = r(e)) && "function" == typeof e.callee ? "Arguments" : u;
      };
    }, function (t, e, n) {

      var r = n(23);
      n(6)({
        target: "RegExp",
        proto: !0,
        forced: r !== /./.exec
      }, {
        exec: r
      });
    }, function (t, e, n) {

      var r = n(6),
          i = n(31)(1);
      r(r.P + r.F * !n(70)([].map, !0), "Array", {
        map: function map(t) {
          return i(this, t, arguments[1]);
        }
      });
    }, function (t, e, n) {

      var r = n(3);

      t.exports = function (t, e) {
        return !!t && r(function () {
          e ? t.call(null, function () {}, 1) : t.call(null);
        });
      };
    }, function (t, e, n) {

      var r = n(2),
          i = n(20),
          o = n(9),
          u = n(14),
          s = n(39),
          c = n(40),
          f = Math.max,
          a = Math.min,
          l = Math.floor,
          p = /\$([$&`']|\d\d?|<[^>]*>)/g,
          g = /\$([$&`']|\d\d?)/g;
      n(42)("replace", 2, function (t, e, n, h) {
        return [function (r, i) {
          var o = t(this),
              u = null == r ? void 0 : r[e];
          return void 0 !== u ? u.call(r, o, i) : n.call(String(o), r, i);
        }, function (t, e) {
          var i = h(n, t, this, e);
          if (i.done) return i.value;
          var l = r(t),
              p = String(this),
              g = "function" == typeof e;
          g || (e = String(e));
          var d = l.global;

          if (d) {
            var y = l.unicode;
            l.lastIndex = 0;
          }

          for (var x = [];;) {
            var A = c(l, p);
            if (null === A) break;
            if (x.push(A), !d) break;
            "" === String(A[0]) && (l.lastIndex = s(p, o(l.lastIndex), y));
          }

          for (var b, m = "", w = 0, Q = 0; Q < x.length; Q++) {
            A = x[Q];

            for (var M = String(A[0]), S = f(a(u(A.index), p.length), 0), k = [], P = 1; P < A.length; P++) {
              k.push(void 0 === (b = A[P]) ? b : String(b));
            }

            var E = A.groups;

            if (g) {
              var O = [M].concat(k, S, p);
              void 0 !== E && O.push(E);
              var T = String(e.apply(void 0, O));
            } else T = v(M, p, S, k, E, e);

            S >= w && (m += p.slice(w, S) + T, w = S + M.length);
          }

          return m + p.slice(w);
        }];

        function v(t, e, r, o, u, s) {
          var c = r + t.length,
              f = o.length,
              a = g;
          return void 0 !== u && (u = i(u), a = p), n.call(s, a, function (n, i) {
            var s;

            switch (i.charAt(0)) {
              case "$":
                return "$";

              case "&":
                return t;

              case "`":
                return e.slice(0, r);

              case "'":
                return e.slice(c);

              case "<":
                s = u[i.slice(1, -1)];
                break;

              default:
                var a = +i;
                if (0 === a) return n;

                if (a > f) {
                  var p = l(a / 10);
                  return 0 === p ? n : p <= f ? void 0 === o[p - 1] ? i.charAt(1) : o[p - 1] + i.charAt(1) : n;
                }

                s = o[a - 1];
            }

            return void 0 === s ? "" : s;
          });
        }
      });
    }, function (t, e, n) {
      var r = n(0),
          i = n(33),
          o = n(7).f,
          u = n(35).f,
          s = n(38),
          c = n(41),
          _f = r.RegExp,
          a = _f,
          l = _f.prototype,
          p = /a/g,
          g = /a/g,
          h = new _f(p) !== p;

      if (n(1) && (!h || n(3)(function () {
        return g[n(4)("match")] = !1, _f(p) != p || _f(g) == g || "/a/i" != _f(p, "i");
      }))) {
        _f = function f(t, e) {
          var n = this instanceof _f,
              r = s(t),
              o = void 0 === e;
          return !n && r && t.constructor === _f && o ? t : i(h ? new a(r && !o ? t.source : t, e) : a((r = t instanceof _f) ? t.source : t, r && o ? c.call(t) : e), n ? this : l, _f);
        };

        for (var v = function v(t) {
          (t in _f) || o(_f, t, {
            configurable: !0,
            get: function get() {
              return a[t];
            },
            set: function set(e) {
              a[t] = e;
            }
          });
        }, d = u(a), y = 0; d.length > y;) {
          v(d[y++]);
        }

        l.constructor = _f, _f.prototype = l, n(12)(r, "RegExp", _f);
      }

      n(73)("RegExp");
    }, function (t, e, n) {

      var r = n(0),
          i = n(7),
          o = n(1),
          u = n(4)("species");

      t.exports = function (t) {
        var e = r[t];
        o && e && !e[u] && i.f(e, u, {
          configurable: !0,
          get: function get() {
            return this;
          }
        });
      };
    }, function (t, e, n) {

      n.r(e), n.d(e, "UserAgent", function () {
        return h;
      }), n.d(e, "getVersionFromUA", function () {
        return g;
      }), n.d(e, "compareVersion", function () {
        return p;
      });
      var r = n(24),
          i = n.n(r),
          o = (n(45), n(43)),
          u = n.n(o),
          s = n(44),
          c = n.n(s),
          f = (n(48), n(50), n(54), n(64), n(69), n(71), n(72), /\d+([._]\d+)*/);

      function a(t) {
        var e,
            n = f.exec(t);
        return null !== (e = null == n ? void 0 : n[0].replace(/_/g, ".")) && void 0 !== e ? e : null;
      }

      function l(t) {
        var e = a(t);
        return (null == e ? void 0 : e.split(".").map(Number)) || [];
      }

      function p(t, e) {
        return n = l(t), r = l(e), (i = Array(Math.max(n.length, r.length)).fill(0).map(function (t, e) {
          return (n[e] || 0) - (r[e] || 0);
        }).find(function (t) {
          return 0 !== t;
        }) || 0) < 0 ? -1 : i > 0 ? 1 : 0;
        var n, r, i;
      }

      function g(t, e) {
        var n;

        try {
          n = new RegExp("\\b".concat(t, "\\W+\\d+([\\._]\\d+)*"), "i");
        } catch (t) {
          return null;
        }

        var r = n.exec(e);
        return r ? a(r[0].substring(t.length)) : null;
      }

      var h = function () {
        function t(e) {
          var n = this;
          u()(this, t), this.userAgent = "", this.getAndroidVersion = function () {
            return n.isAndroid ? g("Android", n.userAgent) : null;
          }, this.isAndroidVersionAboveOrEqual = function (t) {
            return p(n.getAndroidVersion() || "", t) >= 0;
          }, this.getIOSVersion = function () {
            return n.isIOS ? g("OS", n.userAgent) : null;
          }, this.isIOSVersionAboveOrEqual = function (t) {
            return p(n.getIOSVersion() || "", t) >= 0;
          }, this.getPCQQBrowserVersion = function () {
            return n.isPCQQBrowser ? g("QQBrowser", n.userAgent) : null;
          }, this.isPCQQBrowserVersionAboveOrEqual = function (t) {
            return p(n.getPCQQBrowserVersion() || "", t) >= 0;
          }, this.getMobileQQBrowserVersion = function () {
            return n.isMobileQQBrowser ? g("MQQBrowser", n.userAgent) : null;
          }, this.isMobileQQBrowserVersionAboveOrEqual = function (t) {
            return p(n.getMobileQQBrowserVersion() || "", t) >= 0;
          }, this.getChromeVersion = function () {
            return g("Chrome", n.userAgent);
          }, this.isChromeVersionAboveOrEqual = function (t) {
            return p(n.getChromeVersion() || "", t) >= 0;
          }, this.getWeChatVersion = function () {
            return n.isWeChat || n.isWxMiniProgram ? g("MicroMessenger", n.userAgent) : null;
          }, this.isWeChatVersionAboveOrEqual = function (t) {
            return p(n.getWeChatVersion() || "", t) >= 0;
          }, this.getWxDriveVersion = function () {
            return n.isWxDrive ? g("WXDrive", n.userAgent) : null;
          }, this.isWxDriveVersionAboveOrEqual = function (t) {
            return p(n.getWxDriveVersion() || "", t) >= 0;
          }, this.getWxWorkVersion = function () {
            return n.isWxWork ? g("wxwork", n.userAgent) : null;
          }, this.isWxWorkVersionAboveOrEqual = function (t) {
            return p(n.getWxWorkVersion() || "", t) >= 0;
          }, this.getQQVersion = function () {
            return n.isQQ || n.isQQMiniProgram ? g("QQ", n.userAgent) : null;
          }, this.isQQVersionAboveOrEqual = function (t) {
            return p(n.getQQVersion() || "", t) >= 0;
          }, this.getTimVersion = function () {
            return n.isTim ? g("TIM", n.userAgent) : null;
          }, this.isTimVersionAboveOrEqual = function (t) {
            return p(n.getTimVersion() || "", t) >= 0;
          }, this.getTencentDocsAppVersion = function () {
            return g("TencentDocs", n.userAgent);
          }, this.isTencentDocsAppVersionAboveOrEqual = function (t) {
            return p(n.getTencentDocsAppVersion() || "", t) >= 0;
          }, this.getPCTencentDocsClientVersion = function () {
            return g("TxDocsPC", n.userAgent);
          }, this.isPCTencentDocsClientVersionAboveOrEqual = function (t) {
            return p(n.getPCTencentDocsClientVersion() || "", t) >= 0;
          }, this.getElectronTencentDocsClientVersion = function () {
            return g("TDAppDesktop", n.userAgent);
          }, this.isElectronTencentDocsClientVersionAboveOrEqual = function (t) {
            return p(n.getElectronTencentDocsClientVersion() || "", t) >= 0;
          }, void 0 === e && (e = "undefined" != typeof navigator ? navigator.userAgent : ""), Object.defineProperty(this, "userAgent", {
            value: e,
            writable: !1
          });
        }

        return c()(t, [{
          key: "isMobile",
          get: function get() {
            return /(mobile)/i.test(this.userAgent) || this.isAndroidPad;
          }
        }, {
          key: "isMobilePhone",
          get: function get() {
            return /(mobile)/i.test(this.userAgent) && !this.isIPad;
          }
        }, {
          key: "isIPhone",
          get: function get() {
            return /(iphone)/i.test(this.userAgent);
          }
        }, {
          key: "isIPad",
          get: function get() {
            return /(ipad)/i.test(this.userAgent);
          }
        }, {
          key: "isAndroidPhone",
          get: function get() {
            return /(mobile)/i.test(this.userAgent) && this.isAndroid;
          }
        }, {
          key: "isAndroidPad",
          get: function get() {
            return !/(mobile)/i.test(this.userAgent) && this.isAndroid;
          }
        }, {
          key: "isPC",
          get: function get() {
            return !this.isMobile;
          }
        }, {
          key: "isMac",
          get: function get() {
            return !this.isMobile && /Mac OS X/i.test(this.userAgent);
          }
        }, {
          key: "isIPadEmulatedMac",
          get: function get() {
            return this.isMac && navigator.maxTouchPoints > 1;
          }
        }, {
          key: "isAndroid",
          get: function get() {
            return /android|adr/i.test(this.userAgent);
          }
        }, {
          key: "isIOS",
          get: function get() {
            return /(iphone|ipad|ipod)/i.test(this.userAgent);
          }
        }, {
          key: "isWindows",
          get: function get() {
            return /(win64|wow64|win32|wow32|windows nt)/i.test(this.userAgent);
          }
        }, {
          key: "isWindowsUWP",
          get: function get() {
            return /MSAppHost/i.test(this.userAgent);
          }
        }, {
          key: "isLinux",
          get: function get() {
            return /linux/i.test(this.userAgent) && !this.isAndroid;
          }
        }, {
          key: "isLinuxKylin",
          get: function get() {
            return /linux-kylin/i.test(this.userAgent);
          }
        }, {
          key: "isLinuxUOS",
          get: function get() {
            return /linux-uos/i.test(this.userAgent);
          }
        }, {
          key: "isPCQQBrowser",
          get: function get() {
            return !this.isMobile && /QQBrowser/i.test(this.userAgent) && !/QBCore/i.test(this.userAgent);
          }
        }, {
          key: "isMobileQQBrowser",
          get: function get() {
            return this.isMobile && /MQQBrowser/i.test(this.userAgent) && !this.isTimOrQQ && !this.isWeChat && !this.isWxWork && !this.isTencentDocsApp && !this.isWeiYunApp && !this.isMiniProgram;
          }
        }, {
          key: "isQQBrowser",
          get: function get() {
            return this.isMobile ? this.isMobileQQBrowser : this.isPCQQBrowser;
          }
        }, {
          key: "isChrome",
          get: function get() {
            return /(Chrome|CriOS)\/\S+( Mobile\S*)? Safari\/\S+$/i.test(this.userAgent);
          }
        }, {
          key: "isSafari",
          get: function get() {
            return /Version\/\S+( Mobile\S*)? Safari\/\S+$/i.test(this.userAgent);
          }
        }, {
          key: "isIE",
          get: function get() {
            return /MSIE/i.test(this.userAgent) && !/opera/i.test(this.userAgent) || /Trident/i.test(this.userAgent);
          }
        }, {
          key: "isOldEdge",
          get: function get() {
            return /Edge/i.test(this.userAgent);
          }
        }, {
          key: "isChromiumEdge",
          get: function get() {
            return /Edg\//i.test(this.userAgent);
          }
        }, {
          key: "isFirefox",
          get: function get() {
            return /(Firefox|Focus|FxiOS)\//i.test(this.userAgent);
          }
        }, {
          key: "isWeChat",
          get: function get() {
            return /MicroMessenger/i.test(this.userAgent) && !this.isWxWork && !this.isWxMiniProgram;
          }
        }, {
          key: "isWxWork",
          get: function get() {
            return /(wxwork)/i.test(this.userAgent);
          }
        }, {
          key: "isWxDrive",
          get: function get() {
            return /WXDrive/i.test(this.userAgent);
          }
        }, {
          key: "isQQ",
          get: function get() {
            return /QQ\//i.test(this.userAgent) && !this.isTencentDocsApp && !this.isQQMiniProgram && !this.isTim;
          }
        }, {
          key: "isQQForGooglePlay",
          get: function get() {
            return /QQ\//i.test(this.userAgent) && /_GM/i.test(this.userAgent);
          }
        }, {
          key: "isTim",
          get: function get() {
            return /TIM/i.test(this.userAgent);
          }
        }, {
          key: "isPCTim",
          get: function get() {
            return /QBCore/i.test(this.userAgent) && /TIM2.0/i.test(this.userAgent);
          }
        }, {
          key: "isTimOrQQ",
          get: function get() {
            return this.isTim || this.isQQ;
          }
        }, {
          key: "isTimOrQQFamily",
          get: function get() {
            return this.isTim || /QQ/i.test(this.userAgent);
          }
        }, {
          key: "isMiniProgram",
          get: function get() {
            return /miniprogram|miniapp(?!enable)/i.test(this.userAgent) || "undefined" != typeof __wxjs_environment && "miniprogram" === __wxjs_environment;
          }
        }, {
          key: "isWxMiniProgram",
          get: function get() {
            return /MicroMessenger/i.test(this.userAgent) && this.isMiniProgram;
          }
        }, {
          key: "isQQMiniProgram",
          get: function get() {
            return /QQ\/|TIM/i.test(this.userAgent) && this.isMiniProgram;
          }
        }, {
          key: "isWxNativeMiniProgram",
          get: function get() {
            return !this.isQQNativeMiniProgram && "object" === ("undefined" == typeof wx ? "undefined" : i()(wx)) && "function" == typeof wx.canIUse && !0 === wx.canIUse("request");
          }
        }, {
          key: "isQQNativeMiniProgram",
          get: function get() {
            return "object" === ("undefined" == typeof qq ? "undefined" : i()(qq)) && "function" == typeof qq.canIUse && !0 === qq.canIUse("request");
          }
        }, {
          key: "isNativeMiniProgram",
          get: function get() {
            return this.isWxNativeMiniProgram || this.isQQNativeMiniProgram;
          }
        }, {
          key: "isTencentDocsApp",
          get: function get() {
            return /TencentDocs/i.test(this.userAgent);
          }
        }, {
          key: "isPCTencentDocsClient",
          get: function get() {
            return /TxDocsPC/i.test(this.userAgent);
          }
        }, {
          key: "isPCTencentDocsApp",
          get: function get() {
            return this.isPCTencentDocsClient;
          }
        }, {
          key: "isElectronTencentDocsClient",
          get: function get() {
            return /TDAppDesktop/i.test(this.userAgent);
          }
        }, {
          key: "isWeiYunApp",
          get: function get() {
            return /weiyun/i.test(this.userAgent);
          }
        }, {
          key: "isSouGou",
          get: function get() {
            return /SE 2\.X MetaSr 1\.0/i.test(this.userAgent);
          }
        }, {
          key: "isTencentMeeting",
          get: function get() {
            return /tencent_wemeet/i.test(this.userAgent);
          }
        }]), t;
      }();

      e["default"] = new h();
    }]);
  });
})(dist);

var ua = /*@__PURE__*/getDefaultExportFromCjs(dist.exports);

function randomStr(length) {
    var temp = '';
    for (var i = 0; i < length; i++) {
        temp += Math.random()
            .toString(36)
            .substr(2);
    }
    return temp;
}

function getBasicClientVars() {
    var _a;
    return (_a = window.basicClientVars) !== null && _a !== void 0 ? _a : {};
}
function getClientVars() {
    var _a;
    return (_a = window.clientVars) !== null && _a !== void 0 ? _a : {};
}

var _a;
var isWeworkEnv = (((_a = window.location) === null || _a === void 0 ? void 0 : _a.hostname) === 'doc.weixin.qq.com');

function tdwEscapes(target) {
    return target
        .replace(/&/g, '\\&')
        .replace(/\|/g, '\\|')
        .replace(/=/g, '\\=')
        .replace(/%/g, '\\%')
        .replace(/\r/g, '\\r')
        .replace(/\n/g, '\\n')
        .replace(/\t/g, '\\t');
}

var cacheUin = null;
var cacheUid = null;
var source3Cache = null;
function getCookieUin$1() {
    if (cacheUin) {
        return cacheUin;
    }
    var uinInCookie = getCookie('p_luin') || getCookie('p_uin');
    if (uinInCookie) {
        cacheUin = uinInCookie.replace(/^[o0]+/i, '');
    }
    return cacheUin;
}
function getUidFromMulti() {
    var _a;
    return ((_a = window.global_multi_user) === null || _a === void 0 ? void 0 : _a.uid) || null;
}
function getCookieUid$1() {
    if (cacheUid) {
        return cacheUid;
    }
    var uidInCookie = getCookie('uid');
    if (uidInCookie) {
        cacheUid = uidInCookie;
    }
    return cacheUid;
}
function getUin() {
    return getCookieUin$1() || getUinFromClientVars() || getUidForReport();
}
function getUidForReport() {
    return getUidFromMulti() || getCookieUid$1() || getUidFromClientVars();
}
function getUinFromClientVars() {
    var _a;
    return ((_a = getBasicClientVars().userInfo) === null || _a === void 0 ? void 0 : _a.uin) || getClientVars().uin || null;
}
function getUidFromClientVars() {
    var _a, _b;
    return ((_a = getBasicClientVars().userInfo) === null || _a === void 0 ? void 0 : _a.userId) || ((_b = getClientVars().userInfo) === null || _b === void 0 ? void 0 : _b.uid) || null;
}
function getBrowserStr() {
    var _a;
    try {
        var storageStr = (_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem('browserStr');
        if (!storageStr) {
            storageStr = randomStr(5);
            if (window.localStorage) {
                window.localStorage.setItem('browserStr', storageStr);
            }
        }
        return storageStr;
    }
    catch (error) {
        return randomStr(5);
    }
}
function getSource3() {
    if (source3Cache) {
        return source3Cache;
    }
    var adtag = getUrlParameter('adtag');
    if (adtag) {
        source3Cache = adtag;
        setCookie('adtag', adtag, 24 * 365, '.docs.qq.com', '/');
        localStorage.setItem('tdsourcetag', adtag);
    }
    else {
        var tdsourcetag = getUrlParameter('tdsourcetag');
        if (tdsourcetag) {
            source3Cache = tdsourcetag;
            setCookie('adtag', tdsourcetag, 24 * 365, '.docs.qq.com', '/');
            localStorage.setItem('tdsourcetag', tdsourcetag);
        }
        else {
            var fromPageTag = getUrlParameter('from_page');
            if (fromPageTag) {
                source3Cache = fromPageTag;
                setCookie('adtag', fromPageTag, 24 * 365, '.docs.qq.com', '/');
                localStorage.setItem('tdsourcetag', fromPageTag);
            }
        }
    }
    if (!source3Cache) {
        source3Cache = localStorage.getItem('tdsourcetag') || getCookie('adtag') || '';
    }
    return source3Cache;
}
function getUinTypeForReport() {
    var isGuest = getClientVars().userIsGuest;
    if (isGuest)
        return 3;
    if (!getUin())
        return 3;
    var utype = getCookie('utype');
    if (!utype || !UTYPE_MAP[utype]) {
        return errorNumber;
    }
    return UTYPE_MAP[utype];
}
function getFileTypeStrForReport() {
    var _a, _b;
    return ((_b = (_a = getBasicClientVars().docInfo) === null || _a === void 0 ? void 0 : _a.padInfo) === null || _b === void 0 ? void 0 : _b.padType) || getClientVars().padType;
}
function getFileTypeForReport$1(rawFileType) {
    if (rawFileType === void 0) { rawFileType = ''; }
    var fileTypeStr = getFileTypeStrForReport() || rawFileType;
    if (!fileTypeStr || !FILE_TYPE_MAP[fileTypeStr]) {
        return errorNumber;
    }
    return FILE_TYPE_MAP[fileTypeStr];
}
function getIsOwner() {
    var _a;
    var isOwner = ((_a = getBasicClientVars().docInfo) === null || _a === void 0 ? void 0 : _a.isOwner) || getClientVars().isOwner;
    if (typeof isOwner === 'undefined') {
        return errorNumber;
    }
    return isOwner ? booleanToNumber.trueNumber : booleanToNumber.falseNumber;
}
function getAuth$1(rightFlag) {
    var _a;
    return rightFlag || ((_a = getBasicClientVars().authInfo) === null || _a === void 0 ? void 0 : _a.privilegeFlag) || getClientVars().rightFlag || errorNumber;
}
function getPadTitle() {
    var _a, _b;
    var title = ((_b = (_a = getBasicClientVars().docInfo) === null || _a === void 0 ? void 0 : _a.padInfo) === null || _b === void 0 ? void 0 : _b.padTitle) || getClientVars().padTitle;
    if (!title) {
        return null;
    }
    return tdwEscapes(title);
}
function getGlobalPadId() {
    var domainId = getDomainId();
    var padId = getPadId();
    if (domainId && padId) {
        return "".concat(domainId, "$").concat(padId);
    }
    return getClientVars().globalPadId || null;
}
function getCreatorId() {
    var _a;
    return ((_a = getBasicClientVars().createInfo) === null || _a === void 0 ? void 0 : _a.creatorId) || getClientVars().creatorId || null;
}
function getDomainId() {
    var _a, _b;
    return ((_b = (_a = getBasicClientVars().docInfo) === null || _a === void 0 ? void 0 : _a.padInfo) === null || _b === void 0 ? void 0 : _b.domainId) || getClientVars().domainId || null;
}
function getPadId() {
    var _a, _b;
    return ((_b = (_a = getBasicClientVars().docInfo) === null || _a === void 0 ? void 0 : _a.padInfo) === null || _b === void 0 ? void 0 : _b.padId) || getClientVars().padId || null;
}
function getOwnerId() {
    var _a, _b;
    return ((_b = (_a = getBasicClientVars().docInfo) === null || _a === void 0 ? void 0 : _a.ownerInfo) === null || _b === void 0 ? void 0 : _b.ownerId) || getClientVars().ownerId || null;
}
function getGlobalReleaseVersion() {
    return window.__globalReleaseVersion || null;
}
function getApID() {
    var _a, _b;
    return ((_b = (_a = getClientVars().collab_client_vars) === null || _a === void 0 ? void 0 : _a.apid) === null || _b === void 0 ? void 0 : _b.apid) || null;
}
function getWeworkExtralDatas() {
    if (!isWeworkEnv) {
        return {};
    }
    return {
        work_weixin_ext: JSON.stringify({
            corpid: getCorpId(),
            itemname: '',
            vid: getUidForReport(),
            logid: '',
        }),
        work_weixin_source: '',
    };
}
function getCorpId() {
    var _a, _b;
    return ((_a = getBasicClientVars().userInfo) === null || _a === void 0 ? void 0 : _a.corpId) || ((_b = getClientVars().userInfo) === null || _b === void 0 ? void 0 : _b.corp_id) || null;
}
function getPlatform$1() {
    if (ua.isMobile) {
        if (ua.isAndroid) {
            return 2;
        }
        if (ua.isIOS) {
            if (ua.isIPad) {
                return 6;
            }
            return 3;
        }
        return 4;
    }
    if (ua.isMac) {
        return 5;
    }
    if (ua.isLinuxUOS) {
        return 9;
    }
    if (ua.isLinuxKylin) {
        return 8;
    }
    if (ua.isLinux) {
        return 7;
    }
    if (ua.isPCTencentDocsClient || ua.isWindows) {
        return 1;
    }
    return errorNumber;
}
function getSource1$1() {
    var sourceFlags = [
        [ua.isPCTencentDocsClient, 10],
        [ua.isTencentMeeting, 14],
        [ua.isTim, 2],
        [ua.isWxMiniProgram, 3],
        [ua.isWeChat, 4],
        [ua.isTencentDocsApp, 6],
        [ua.isWindowsUWP, 8],
        [ua.isQQ, 1],
        [ua.isWxWork, 9],
        [ua.isWeiYunApp, 11],
        [ua.isQQMiniProgram, 12],
        [ua.isElectronTencentDocsClient, 13],
        [ua.isQQBrowser, 5],
        [ua.isMobileQQBrowser, 5],
        [ua.isChrome, 5],
        [ua.isQQBrowser, 5],
        [ua.isSafari, 5],
        [ua.isOldEdge, 5],
        [ua.isIE, 5],
        [ua.isChromiumEdge, 5],
        [ua.isFirefox, 5],
    ];
    for (var i = 0; i < sourceFlags.length; i++) {
        var _a = sourceFlags[i], sourceFlag = _a[0], value = _a[1];
        if (sourceFlag) {
            return value;
        }
    }
    return errorNumber;
}
function getAbTest() {
    return window.ExpIdList || null;
}
function getCreatorCor() {
    var clientVars = getClientVars();
    var corpName = clientVars.userLoginCorpName;
    var corpId = clientVars.userLoginCorpId;
    if (!corpName || !corpId) {
        var userInfo = clientVars.userInfo || {};
        corpName = userInfo.corp_name;
        corpId = userInfo.corp_id;
    }
    if (corpName && corpId) {
        return "".concat(corpName, "-").concat(corpId);
    }
    return null;
}
function getDocsAppVersion() {
    if (ua.isElectronTencentDocsClient) {
        return getVersionWithName('TDAppDesktop');
    }
    if (ua.isPCTencentDocsClient) {
        return getVersionWithName('TxDocsPC');
    }
    if (ua.isTencentDocsApp) {
        return getVersionWithName('TencentDocs');
    }
}
function getTestEnv() {
    return getCookie('free_go_proxy') || getCookie('env_name') || getCookie('env_id') || getCookie('fd');
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

var defaultTdwData = {};
var hasOwnerId = false;
var hasUserInfo = false;
function getDefaultTdwData$1() {
    var clientVars = getClientVars();
    if (!hasOwnerId && clientVars.ownerId) {
        hasOwnerId = true;
        resetDefaultTdwData$1();
    }
    if (!hasUserInfo && clientVars.userInfo) {
        hasUserInfo = true;
        resetDefaultTdwData$1();
    }
    return defaultTdwData;
}
function resetDefaultTdwData$1(customDatas) {
    if (customDatas === void 0) { customDatas = {}; }
    Object.assign(defaultTdwData, _assign({ table: 'dc03111', third_appid: getApID(), uin: getUin(), uid: getUidForReport(), user_mac: getBrowserStr(), uin_type: getUinTypeForReport(), platform: getPlatform$1(), appid: getDocsAppVersion(), touin: getCreatorId(), isOwner: getIsOwner(), file_type: getFileTypeForReport$1(), id: getPadId(), source1: getSource1$1(), source2: '', source3: getCreatorCor() || getSource3(), obj1: getAuth$1(), obj2: getPadTitle(), ver1: getGlobalPadId(), ver2: getCreatorId(), ver3: getDomainId(), ver4: getOwnerId(), web_version: getGlobalReleaseVersion(), abtest: getAbTest() }, getWeworkExtralDatas()), customDatas);
    var testEnv = getTestEnv();
    if (testEnv) {
        defaultTdwData.dev_route_id = testEnv;
    }
}

var GLOBAL_VAR = 'tencentDocReport';
var SDK_BUNDLE_URL = 'https://tencent-doc.cdn-go.cn/doc-report/3.0/report.js';

var reportProxyID = '@tencent-tencent-doc-report';
function injectScript(url, globalVarString) {
    return new Promise(function (resolve) {
        var script = document.createElement('script');
        script.async = true;
        script.src = url;
        script.id = reportProxyID;
        script.crossOrigin = 'anonymous';
        script.setAttribute('retry-when-error', 'true');
        script.onload = function () {
            var globalVar = window[globalVarString];
            resolve(globalVar);
        };
        if (!window.tencentDocReportInjected) {
            window.tencentDocReportInjected = true;
            (document.head || document.body).appendChild(script);
        }
    });
}
function safeStringify(obj) {
    var seen = new Set();
    return JSON.stringify(obj, function (key, value) {
        if (isObject(value) || Array.isArray(value)) {
            if (seen.has(value)) {
                return '[Circular]';
            }
            seen.add(value);
        }
        return value;
    });
}
function isObject(obj) {
    return isType('Object', obj);
}
function isType(type, obj) {
    return Object.prototype.toString.call(obj) === "[object ".concat(type, "]");
}

function isFunctionType(caller) {
    return 'functionName' in caller;
}

function init(sdkUrl) {
    if (window.tencentDocReportInjected)
        return;
    injectScript(sdkUrl, GLOBAL_VAR).then(function () {
        var _a, _b;
        if (!window.tencentDocReportBuffers)
            return;
        for (var _i = 0, _c = window.tencentDocReportBuffers; _i < _c.length; _i++) {
            var caller = _c[_i];
            if (isFunctionType(caller)) {
                (_a = window.tencentDocReport)[caller.functionName].apply(_a, JSON.parse(caller.argsStringified));
            }
            else {
                (_b = window.tencentDocReport[caller.className])[caller.methodName].apply(_b, JSON.parse(caller.argsStringified));
            }
        }
    })
        .then(function () {
        clearBuffers();
    })
        .catch(function () {
        clearBuffers();
    });
}
function invokeClassMethod(className, methodName, args) {
    var _a;
    try {
        if (window.tencentDocReport) {
            (_a = window.tencentDocReport[className])[methodName].apply(_a, args);
            return;
        }
        pushBuffer({ className: className, methodName: methodName, argsStringified: safeStringify(args) });
    }
    catch (error) {
        console.error(error);
    }
}
function invokeFunction(functionName, args) {
    var _a;
    try {
        if (window.tencentDocReport) {
            (_a = window.tencentDocReport)[functionName].apply(_a, args);
            return;
        }
        pushBuffer({ functionName: functionName, argsStringified: safeStringify(args) });
    }
    catch (error) {
        console.error(error);
    }
}
function pushBuffer(buffer) {
    var _a;
    (_a = window.tencentDocReportBuffers) !== null && _a !== void 0 ? _a : (window.tencentDocReportBuffers = []);
    window.tencentDocReportBuffers.push(buffer);
}
function clearBuffers() {
    window.tencentDocReportBuffers = [];
    delete window.tencentDocReportBuffers;
}

var LogPadType = {
    Sheet: 'sheet',
    Backend: 'backend',
    WxJsSdk: 'WxJsSdk',
    Mqq: 'Mqq',
    Fc: 'fc',
    Sc: 'sc',
    Ark: 'ark',
    DC: 'dc',
    Doc: 'doc',
    BlankPage: 'blankPage',
    Slide: 'slide',
    PDF: 'pdf',
    Form: 'form',
    Scenario: 'scenario',
    SmartSheet: 'smartSheet',
};

init(SDK_BUNDLE_URL);
function tdw() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    invokeFunction('tdw', params);
}
function tdwSingle() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    invokeFunction('tdwSingle', params);
}
function reportErrorCode() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    invokeFunction('reportErrorCode', params);
}
function webLogAndEsReport() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    invokeFunction('webLogAndEsReport', params);
}
function tipReport() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    invokeFunction('tipReport', params);
}
function webLog() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    invokeFunction('webLog', params);
}
function esLogReport() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    invokeFunction('esLogReport', params);
}
var KVR = {
    init: function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        invokeClassMethod('KVR', 'init', params);
    },
    oss: function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        invokeClassMethod('KVR', 'oss', params);
    },
};
function zzsStatus() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    invokeFunction('zzsStatus', params);
}
function zzsValue() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    invokeFunction('zzsValue', params);
}
function idkey() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    invokeFunction('idkey', params);
}
function resetDefaultTdwData() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    invokeFunction('resetDefaultTdwData', params);
}
function getDefaultTdwData() {
    return getDefaultTdwData$1();
}
function getCookieUid() {
    return getCookieUid$1();
}
function getCookieUin() {
    return getCookieUin$1();
}
function getFileTypeForReport(rawFileType) {
    return getFileTypeForReport$1(rawFileType);
}
function getAuth(rightFlag) {
    return getAuth$1(rightFlag);
}
function getSource1() {
    return getSource1$1();
}
function getPlatform() {
    return getPlatform$1();
}
function monitor() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    invokeFunction('monitor', params);
}
function retcode() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    invokeFunction('retcode', params);
}
function huatuo() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    invokeFunction('huatuo', params);
}

export { KVR, LogPadType, esLogReport, getAuth, getCookieUid, getCookieUin, getDefaultTdwData, getFileTypeForReport, getPlatform, getSource1, huatuo, idkey, monitor, reportErrorCode, resetDefaultTdwData, retcode, tdw, tdwSingle, tipReport, webLog, webLogAndEsReport, zzsStatus, zzsValue };
